
import { FC } from "react";
import styled from "@emotion/native";
import IconButton from "./Buttons/IconButton";

import PayBooks from '@assets/icons/drawer/paybook';
import Close from '@assets/icons/Close';

const Container = styled(IconButton)`
  align-self: flex-end;
  background-color: #FAFAFA;
  border-radius: 5px;
  margin: 0 15px;
  width: auto;
`;

type Props = {
  onPress?: () => void;
};

const DrawerCloseButton: FC<Props> = ({ onPress,...props }) => {
  return ( <Container icon={<Close fill="#CCC" />} onPress={onPress} /> );
};

export default DrawerCloseButton;